import { getConfig } from "src/config.ts";

export const iseaReferenceLink = (iseaReference: string) => {
  return `${getConfig().isea3Url}/pages/request/SearchResult.aspx?q=${encodeURIComponent(iseaReference)}&p=0`;
};
